import ExamsSection from './ExamSection';
export default ExamsSection;
